import React from "react";
import { getImageUrl } from "../utils.js";

export default class PopUpImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showMetadata: false
    };
    this.onImageClick = this.onImageClick.bind(this);
  }

  onImageClick(evt) {
    evt.stopPropagation();
    this.setState({ showMetadata: !this.state.showMetadata });
  }

  render() {
    const { title, tags, farm, server, id, secret } = this.props.image;
    return (
      <div className="image-popup-container" onClick={this.props.hideImage}>
        <div className="image-popup-wrapper">
          <img
            className="popup-image"
            src={getImageUrl(farm, server, id, secret)}
            alt=""
            onClick={this.onImageClick}
          />
          <i onClick={this.props.hideImage} className="fa fa-close fa-2x"></i>
          {this.state.showMetadata && (
            <ul className="image-metadata">
              <li style={{ margin: "5px 0" }}>Title: {title}</li>
              <li style={{ margin: "5px 0" }}>Tags: {tags}</li>
            </ul>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/imagePopup.js